import PropTypes from "prop-types";
import classnames from "classnames";
import NavigationButton from "../NavigationButton";
import "./proposalList.scss";

const ProposalList = ({ className, userSessionProposals }) => {
  if (!userSessionProposals) {
    return <div className="no-proposals">No proposals found.</div>;
  }

  return (
    <ol className={classnames("proposals", className)}>
      {userSessionProposals.map((proposal, index) => {
        const { status, name, active, transitionId } = proposal;
        let iconName, iconPosition;

        switch (status) {
          case "pending":
            iconName = "time";
            iconPosition = "right";
            break;
          case "ready":
            iconName = "system-checkmark";
            iconPosition = "right";
            break;
          default:
            iconName = null;
            iconPosition = "left";
        }

        return (
          <li key={index}>
            <NavigationButton
              label={name}
              ariaLabel={`${name} - ${status}`}
              variant="link"
              squared
              active={active}
              href={`/proposals/${transitionId}`}
              iconPosition={iconPosition}
              iconName={iconName}
            />
          </li>
        );
      })}
    </ol>
  );
};

ProposalList.propTypes = {
  className: PropTypes.string,
  userSessionProposals: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      active: PropTypes.bool,
      status: PropTypes.string,
      transitionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
};

export default ProposalList;
